<template>
    <div class="checkbox-wrapper" :class="[`checkbox--${size}`]" @click="toggle">
        <div class="round">
            <input @change="onChange" type="checkbox" :id="id" :checked="checked" :value="value" />
            <span class="checkmark"></span>
        </div>
        <label class="kv-label">{{ label }}</label>
    </div>
</template>

<script>
export default {
    name: "KvCheckbox",
    props: {
        id: String,
        checked: Boolean,
        modelValue: Boolean,
        value: String,
        label: {
            type: String,
            default: "",
        },
        size: {
            type: String,
            default: "md", // opções: sm, md, lg
            validator: (v) => ["sm", "md", "lg"].includes(v)
        }
    },
    methods: {
        toggle() {
            this.$emit("update:modelValue", !this.modelValue)
        },
        onChange(e) {
            this.$emit("update:modelValue", e.target.checked)
        }
    }
};
</script>

<style lang="scss">
.checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    gap: 8px;

    .kv-label {
        margin-bottom: 0;
    }

    .round {
        position: relative;

        .checkmark {
            background-color: #fff;
            border: 1px solid #D2D6DB;
            border-radius: 6px;
            cursor: pointer;
            display: block;
            transition: all 0.2s ease-in-out;

            &:after {
                border: 2px solid #fff;
                border-top: none;
                border-right: none;
                content: "";
                opacity: 0;
                position: absolute;
                transform: rotate(-45deg);
                transition: opacity 0.2s ease;
            }
        }
    }
}

/* tamanho padrão (md) */
.checkbox--md {
    font-size: 0.9em;

    .round .checkmark {
        width: 20px;
        height: 20px;
    }

    .round .checkmark:after {
        width: 9px;
        height: 5px;
        left: 5.5px;
        top: 6.5px;
    }
}

/* pequeno (sm) */
.checkbox--sm {
    font-size: 0.8em;

    .round .checkmark {
        width: 16px;
        height: 16px;
        border-width: 1.5px;
        border-radius: 4px;
    }

    .round .checkmark:after {
        width: 7px;
        height: 4px;
        left: 4px;
        top: 5px;
    }
}

/* grande (lg) */
.checkbox--lg .round .checkmark {
    width: 28px;
    height: 28px;
    border-width: 2.5px;
    border-radius: 8px;
}

.checkbox--lg .round .checkmark:after {
    width: 13px;
    height: 8px;
    left: 7px;
    top: 9px;
}

/* comportamento padrão */
.checkbox-wrapper .round input[type="checkbox"] {
    visibility: hidden;
    display: none;
}

.checkbox-wrapper .round input[type="checkbox"]:checked+.checkmark {
    background-color: #2AAA4C;
    border-color: #2AAA4C;
}

.checkbox-wrapper .round input[type="checkbox"]:checked+.checkmark:after {
    opacity: 1;
}
</style>
